import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Avatar, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import api from '../../../services/api';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
  },
  avatar: {
    width: 60,
    height: 60,
  },
  name: {
    marginTop: theme.spacing(1),
  },
}));

const Profile = (props) => {
  const { className, ...rest } = props;
  const classes = useStyles();
  const token = localStorage.getItem('@icep-app/token');
  const username = localStorage.getItem('@icep-app/username');
  const idUser = localStorage.getItem('@icep-app/iduser');
  const userType = localStorage.getItem('@icep-app/user');
  const unityId = localStorage.getItem('@icep-app/unity');
  const [unity, setUnity] = useState();

  useEffect(() => {
    async function fetchUnity() {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const resp = await api.get(`/unities/${unityId}`);

      setUnity(resp.data);
    }
    fetchUnity();
  }, [token, unityId]);

  const user = {
    name: username,
    id: idUser,
    avatar: '/images/avatars/user.png',
    bio: userType,
  };

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={user.avatar}
        to="/settings"
      />

      <Typography className={classes.name} variant="h4">
        {user.name}
      </Typography>
      <Typography className={classes.name} variant="body2">
        {unity && unity.description}
      </Typography>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string,
};

export default Profile;
